/* eslint-disable no-console */
/**
 * @module main
 */
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import config from './auth/config';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import {MsalService} from '@ey/voltron-core';
import {initTeamsProvider} from '@ey/canvascoreservices-teams';
import {LicenseManager} from 'ag-grid-enterprise';
import queryString from 'query-string';
import _ from 'lodash';
import {Providers, ProviderState} from '@microsoft/mgt';
import Routes from './components/Routes';
import configureStore from './store/configurestore';
import './util/svg';
import initialState from './reducers/initialstate';
import env from './util/env';
import Utility from './util/utilityfunctions';
import {
	displayLanguages,
	serviceURL,
	guidEmpty,
	attributeListSkipTaskOpen,
	documentsApiExpandableItems
} from './util/uiconstants';
import {labels, setLanguage} from './util/utils';
import {expandableGetFormById} from './util/Ares/customHooks';
import initDocHelper from './components/Common/DocumentHub/DocumentHub';
import TelemetryProvider from './components/Common/AppInsight/TelemetryProvider';
import {getAppInsights} from './components/Common/AppInsight/TelemetryService';
import {getUserPreferences} from './actions/UserPreferences/userpreferencesaction';
import {getQuickLinks} from './actions/Engagement/quicklinksactions';
import {getEngagement, getEngagementRoles, setIsAresView} from './actions/Engagement/engagementactions';
import {getActiveAndGuestFormUsers} from './actions/FormUsers/formusersactions';
import {raiseJSValidationError, raiseInformationMessage} from './actions/erroractions';
import {getInternalUserById} from './actions/UserPreferences/userpreferencesaction';
import {createUserIndependenceForm} from './actions/FormData/formdataactions';
import {
	setEngagementId,
	setIsDrawerMode,
	setIsGuidedWorkFlowV2,
	setHasBodyIdFilter
} from './actions/Engagement/engagementactions';
import {setDocumentId} from './actions/Document/documentactions';
import {getDocumentByDocumentId} from './actions/Ares/taskDocumentActions';
import {getFormValidations} from './components/Main/Ares/Tasks/TaskView/Common/guidedWorkflow.utils';
import {setApprovalsFromDocument} from './actions/Task/signoffsaction';
import {getMateriality} from './actions/Materiality/materialityactions';
import {licenseSetter} from '@ey/canvascoreservices/AGGridEnterprise';

LicenseManager.setLicenseKey(
	// eslint-disable-next-line max-len
	'Using_this_{AG_Grid}_Enterprise_key_{AG-059616}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ernst_&_Young_U.S._LLP}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{EY_Canvas}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{EY_Canvas}_need_to_be_licensed___{EY_Canvas}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_July_2025}____[v3]_[01]_MTc1MzY1NzIwMDAwMA==4f80980272aef5f53d439b27c9ceb64c'
);

licenseSetter(
	// eslint-disable-next-line max-len
	'Using_this_{AG_Grid}_Enterprise_key_{AG-059616}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ernst_&_Young_U.S._LLP}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{EY_Canvas}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{EY_Canvas}_need_to_be_licensed___{EY_Canvas}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_July_2025}____[v3]_[01]_MTc1MzY1NzIwMDAwMA==4f80980272aef5f53d439b27c9ceb64c'
);

let engWeb = env.getURL('eng_web');
let paths = location.pathname.split('/');

if (paths[1].toLowerCase() === 'v1redirect') {
	let queryStringParams = queryString.parse(location.search.toLowerCase());
	const redirectedBy = '&rdFrom=clt';
	if (paths[2]?.toLowerCase() === 'engagementprofile') {
		engWeb = env.getURL('kronos_web') + '/initprofile?engagementid=' + queryStringParams.engagementid;
		engWeb = engWeb + '&referrer=' + env.getURL('Zeus_web') + redirectedBy;
	} else if (queryStringParams.showindependence && queryStringParams.showindependence === 'true') {
		engWeb = env.getURL('kronos_web') + '/independence?engagementid=' + queryStringParams.engagementid;
		engWeb = engWeb + '&referrer=' + env.getURL('Zeus_web') + redirectedBy;
	} else if (queryStringParams.grantarchiveaccess && queryStringParams.grantarchiveaccess === 'true') {
		// Navigate to manage team for archived engagement
		engWeb = location.origin + '/manageteam?engagementid=' + queryStringParams.engagementid;
	} else {
		engWeb = engWeb + '/pages/index/index.html' + location.search + redirectedBy;
	}
	location.href = engWeb;
}

// below listener is added to fix the issue with deep routing for PAAS environments
// TODO: Remove after all features with #routes in v1 are migrated to hercules
const v1redirection = (event) => {
	if (event.ctrlKey || event.shiftKey) {
		return;
	}

	const a = event.target.closest('a');
	if (a && a.attributes['href']) {
		let urlVal = _.trimStart(a.attributes['href'].value, '/');
		let engWeb = env.getURL('eng_web');
		if (urlVal.split(engWeb).length > 1) {
			const svg = event.target.closest('svg');
			if (svg && svg.classList && svg.classList.length > 0 && attributeListSkipTaskOpen.includes(svg.classList[0])) {
				// Return if click on tagIcon in TaskList item
				return;
			}
			if (event.target && event.target.id && attributeListSkipTaskOpen.includes(event.target.id)) {
				// Return if click on tag count in TaskList item
				return;
			}

			if (event.target.closest('.tooltip-Menu-TasklistItem')) {
				// when user click on tooltip menu for tag and service request icon
				return;
			}

			event.preventDefault();
			const hash = new URL(urlVal).hash;
			let urlWithoutHash = urlVal.split('#')[0];
			let isTaskRoute = hash.includes('#task/');
			const openInNewTab = a.dataset.opennewtab;
			if (hash) {
				urlWithoutHash = _.trimEnd(urlWithoutHash, '&') + '&hashRoute=' + hash.split('#')[1];
			}

			if (isTaskRoute || openInNewTab) {
				window.open(urlWithoutHash, '_blank');
			} else {
				window.location.href = urlWithoutHash;
			}
		}
	}
};

window.removeEventListener('click', v1redirection, true);
window.addEventListener('click', v1redirection, true);

const initializeApp = (store, isFitRedirecionUrl) => {
	const state = store.getState();
	const dispatch = store.dispatch;
	const engagement = state.engagement;
	const isAresView = state.isAresView;

	/**
	 * Note: whenever dev adds code here that impact the initial loading of document or engagement setup,
	 * pls make sure to update the useDocumentSwitcher customHook (util/customHook) as well.
	 */

	const isMestEngagement = engagement?.isMultiEntityEngagement;

	let documentId = Utility.getDocumentIdFromUrl(window);

	if (documentId) {
		const getDocumentByIdParameters = {
			expand: documentsApiExpandableItems.tasks,
			includeApprovals: true,
			includeReviewNotes: true
		};

		getDocumentByIdParameters.includeRelatedEntities = true;

		let firstDocumentStEntityId;
		let getDocumentById = new Promise((resolve) => {
			dispatch(
				getDocumentByDocumentId(engagement.engagementId, documentId, getDocumentByIdParameters, isAresView)
			).then((doc) => {
				if (doc.entities?.length > 0) {
					firstDocumentStEntityId = doc.entities[0].id;
				}
				return resolve(doc);
			});
		});

		let getFormById = new Promise((resolve) => {
			dispatch(
				expandableGetFormById(engagement, documentId, undefined, {resolve: true}, undefined, isAresView)
			).then((form) => resolve(form));
		});

		// Get doc byId call needs to be fired before the form byId. Otherwise, fit redirection won't work with MEST engagements
		let documentMetadataPromise = Promise.resolve();
		if (isFitRedirecionUrl) {
			documentMetadataPromise = getDocumentById.then((docResponse) => {
				return getFormById.then((formResponse) => [docResponse, formResponse]);
			});
		} else {
			// It's not a fit redirection url. Both calls can go in parallel
			documentMetadataPromise = Promise.all([getDocumentById, getFormById]);
		}

		documentMetadataPromise
			.then((responses) => {
				let document = responses[0];
				if (document && document.approvals && document.approvals.length > 0) {
					dispatch(setApprovalsFromDocument(document.approvals, document.id));
				}
				const queryParameters = firstDocumentStEntityId ? {stEntityId: firstDocumentStEntityId} : undefined;
				return dispatch(getMateriality(engagement.engagementId, undefined, queryParameters));
			})
			.catch(() => {
				store.dispatch(raiseJSValidationError(labels.invalidDocumentId));
			});

		dispatch(getActiveAndGuestFormUsers(Number(engagement.engagementId), documentId));
	}
};

const initializeDocHelper = (store, authService) => {
	/**
	 * sending UPN using msal logged in account so that docHelper can be initialitzed based on UPN route
	 * DocHelper init is chained to userpreference call so that any error on DocHelper can be displayed in preferred Language
	 */
	const state = store.getState();
	const dispatch = store.dispatch;

	env.setDocHelperConfig(authService.getActiveAccount()?.username).then(() => {
		//initDocHelper -> then initSync
		initDocHelper(store)
			.then(() => {
				console.log('📃 ###Init Dochelper ###');
				if (state.apponlinestate) {
					console.log('STARTING SYNC IN main.js after HOME_LOGIN');
					dispatch({
						type: 'START_OFFLINE_SYNC',
						docHelperConfig: env.getDocHelperConfig()
					});
				}
			})
			.catch((e) => {
				console.log('Error in docHelperInit: ', e);
				//TODO: Nitin to update the error action to display message about the Knowledge article on DocHelper
			});
	});
};

function initiateEngagement(store, engagementId, authService) {
	const dispatch = store.dispatch;

	return dispatch(getUserPreferences(`${env.getBaseURL(serviceURL, Number(engagementId))}Users/Me`))
		.catch((e) => {
			console.log('Error in getUserPreferences call: ', e);
			dispatch(getEngagementRoles(`${env.getBaseURL(serviceURL)}Roles`));
		})
		.then(() => {
			let state = store.getState();
			let promise = Promise.resolve();
			setLanguage(state.userPreferences.displayLanguage);

			if (!state.userPreferences.isGuestUser) {
				initializeDocHelper(store, authService);
				promise = () => dispatch(getInternalUserById(Number(engagementId), state.userPreferences.id, true));
				return promise().then(() => {
					state = store.getState();
					let isEngagementAccessible =
						!state.userPreferences.isGuestUser && state.internalUser?.independenceInformation?.isEngagementAccessible;

					return dispatch(getEngagement(engagementId, isEngagementAccessible)).catch((result) => {
						if (result && result.response && result.response.status === 403) {
							dispatch(raiseJSValidationError(labels.invalidEngagementId));
						}
					});
				});
			} else {
				state = store.getState();
				let isEngagementAccessible =
					!state.userPreferences.isGuestUser && state.internalUser?.independenceInformation?.isEngagementAccessible;

				return dispatch(getEngagement(engagementId, isEngagementAccessible)).catch((result) => {
					if (result && result.response && result.response.status === 403) {
						dispatch(raiseJSValidationError(labels.invalidEngagementId));
					}
				});
			}
		});
}

function onInitGuidedWorkflow(store, engagementId, authService, isFitRedirectionUrl) {
	const dispatch = store.dispatch;

	return initiateEngagement(store, engagementId, authService).then(() => {
		let state = store.getState();
		initializeApp(store, isFitRedirectionUrl);
		setLanguage(state.userPreferences.displayLanguage);
		dispatch(getEngagementRoles(`${env.getBaseURL(serviceURL)}Roles`));
	});
}

document.addEventListener('DOMContentLoaded', () => {
	console.log('🌵 <<< DOM loaded >>> 🌵');

	const store = configureStore(initialState);

	const dispatch = store.dispatch;

	dispatch({type: 'HOME_LOGIN'}).then(() => {
		$('<iframe />')
			.attr({
				id: 'communicationchannel',
				src: `${env.getURL('Zeus_web')}/pages/communicationChannel/communicationchannel.html`
			})
			.hide()
			.appendTo('body');

		//  get PAANS User information
		/*let paansUrl = env.getBaseURL(serviceURL) + 'Paans';
			store
				.dispatch(checkUserAcceptedPaansPolicy(paansUrl))
				.then(() => {
					let userHasAcceptedPolicy = store.getState().paansUserData;
					let hasaccepted = userHasAcceptedPolicy.hasAccepted;
					let redirectUrl = userHasAcceptedPolicy.redirectUrl;
					if (hasaccepted !== undefined && redirectUrl !== undefined) {
						if (hasaccepted === false) {
							window.location.href = redirectUrl;
						}
					}
				})
				.catch((paansError) => {
					let errorMessage = utility.getErrorMessageFromResponse(utility.getErrorMessage(paansError));
					console.log('Error in PAANS: ', errorMessage);
				});*/

		const authService = new MsalService(config);
		const account = authService.getActiveAccount();

		if (account) {
			initTeamsProvider(config)
				.then((provider) => {
					Providers.globalProvider = provider;
					Providers.globalProvider.setState(ProviderState.SignedIn);
				})
				.catch((error) => {
					console.log('error', error);
				});
		}
		// TODO: below code should be moved to initCommunicationChannel

		let engagementId = Utility.getEngagementIdFromUrl(window);

		if (engagementId && engagementId instanceof Array) {
			engagementId = engagementId[0];
		}

		dispatch(setEngagementId(engagementId)).catch(() => {
			dispatch(raiseJSValidationError(labels.invalidEngagementId));
		});

		let documentId = Utility.getDocumentIdFromUrl(window);
		if (documentId) {
			dispatch(setDocumentId(documentId)).catch(() => {
				dispatch(raiseJSValidationError(labels.invalidDocumentId));
			});
		}
		const queryParameters = queryString.parse(location.search.toLowerCase());
		const isDrawerMode = queryParameters?.isdrawer && queryParameters.isdrawer.toLowerCase() === 'true';

		dispatch(setIsDrawerMode(isDrawerMode));

		document.addEventListener('contextmenu', (event) => {
			// Check if the right-click is on a link
			const link = event.target.closest('a');
			if (link) {
				link.href = Utility.removeQueryStringProperties(link.href, ['isdrawer', 'framekey', 'target']);
			}
		});

		const pathname = window.location.pathname.toLowerCase();

		const hasBodyIdFilter = queryParameters?.bodyid ? true : false;
		dispatch(setHasBodyIdFilter(hasBodyIdFilter));

		const isGuidedWorkFlowV2 = pathname.indexOf('/guidedworkflowv2') === 0;
		const isGuidedWorkFlowV1 = pathname.indexOf('/guidedworkflow') === 0;

		store.dispatch(setIsGuidedWorkFlowV2(isGuidedWorkFlowV2));

		let isFitRedirectionUrl = pathname.startsWith('/fit');
		if (isFitRedirectionUrl || isGuidedWorkFlowV2 || isGuidedWorkFlowV1) {
			store.dispatch(setIsAresView(true));
		}

		if (pathname === '/initProfile'.toLowerCase()) {
			/*Profile V2 form*/
			dispatch(raiseInformationMessage(labels.gettingProfile));

			dispatch(getQuickLinks(`${env.getBaseURL(serviceURL, Number(engagementId))}QuickLinks`))
				.then(() => {
					if (store.getState().quickLink) {
						const quicklink = store.getState().quickLink;
						if (quicklink) {
							if (quicklink.hasV2Profile) {
								window.location.href = `${new URL(window.location.origin)}fit?engagementid=${engagementId}&documentid=${
									quicklink.profileV2DocumentId
								}`;
							} else {
								let isEngagementAccessible = false;

								dispatch(getEngagement(engagementId, isEngagementAccessible))
									.then(() => {
										let engagement = store.getState().engagement;
										if (engagement) {
											window.location.href = `${env.getURL(
												'eng_web'
											)}/pages/engagementprofilepage/engagementprofile.html?countryid=${
												engagement.countryId
											}&engagementid=${engagementId}&engagementdesc=${engagement.engagementDescription}&userPrefLang=${
												displayLanguages[engagement.languageId].value
											}&workspacedesc=${engagement.workspaceDescription}&workspaceid=${
												engagement.workspaceId
											}&engagementversionfull=${engagement.engagementVersion}`;
										}
									})
									.catch((result) => {
										if (result && result.response && result.response.status === 403) {
											props.raiseJSValidationError(labels.invalidEngagementId);
										}
									});
							}
						} else {
							dispatch(raiseJSValidationError(labels.noProfileInformationFound));
						}
					}
				})
				.catch((result) => {
					if (result && result.response && result.response.status === 403) {
						dispatch(raiseJSValidationError(labels.noProfileInformationFound));
					}
				});
		} else if (pathname === '/independence'.toLowerCase()) {
			/*Independence Form*/
			dispatch(raiseInformationMessage(labels.verifyingIndependence));

			/*get user for user id*/
			dispatch(getUserPreferences(`${env.getBaseURL(serviceURL, Number(engagementId))}Users/Me`))
				.then(() => {
					setLanguage(store.getState().userPreferences.displayLanguage);

					dispatch(getInternalUserById(engagementId, store.getState().userPreferences.id, true))
						.then(() => {
							if (
								store.getState().internalUser &&
								store.getState().internalUser.independenceIndividualDocumentId &&
								store.getState().internalUser.independenceIndividualDocumentId !== guidEmpty
							) {
								window.location.href = `${new URL(window.location.origin)}fit?engagementid=${engagementId}&documentid=${
									store.getState().internalUser.independenceIndividualDocumentId
								}`;
							} else {
								/*create an independence form*/
								let createFormUrl = env.getBaseURL(serviceURL, Number(engagementId)) + 'IndependenceForms';
								dispatch(raiseInformationMessage(labels.creatingIndependenceForm));

								dispatch(createUserIndependenceForm(createFormUrl))
									.then(() => {
										if (store.getState().independenceIndividualDocumentId) {
											window.location.href = `${new URL(
												window.location.origin
											)}fit?engagementid=${engagementId}&documentid=${
												store.getState().independenceIndividualDocumentId
											}`;
										} else {
											dispatch(raiseJSValidationError(labels.independenceFormCreationFailed));
										}
									})
									.catch(() => {
										dispatch(raiseJSValidationError(labels.independenceFormCreationFailed));
									});
							}
						})
						.catch(() => {
							dispatch(raiseJSValidationError(labels.getUserByIdFailed));
						});
				})
				.catch(() => {
					dispatch(raiseJSValidationError(labels.meCallFailed));
				});
		} else {
			onInitGuidedWorkflow(store, engagementId, authService, isFitRedirectionUrl);
		}

		if (window.location.search) {
			if (window.location.search.indexOf('referrer=') > 0) {
				let referrer = window.location.search.substring(
					window.location.search.indexOf('referrer='),
					window.location.search.length
				);
				if (referrer && referrer.length > 0) {
					referrer = referrer.toLowerCase().substring('referrer='.length, referrer.length);
					env.setReturnUrl(referrer);
				}
			}
		}

		const root = ReactDOM.createRoot(document.getElementById('mount'));
		root.render(
			<Provider store={store}>
				{store.getState().apponlinestate ? (
					<TelemetryProvider
						instrumentationKey={env.getInstrumentationKey()}
						after={() => getAppInsights().trackPageView({name: window.location.pathname})}
					>
						<Routes />
					</TelemetryProvider>
				) : (
					<Routes />
				)}
			</Provider>
		);
	});
});
